export default __webpack_public_path__ + "static/HallOfFameLogo-8365938e8df4c162b558b0b3fab4a9c5.webp";